import { useState } from "react";
import { useHistory } from "react-router-dom";

import { isCompressedItself } from "../../../../../utils/function";

// OS/R cell: shows the machine of the submission and turns into a
// "PDF" shortcut on hover, opening the report export page for that row.
const OsReportExport = (props) => {
  const history = useHistory();

  const [hovered, setHovered] = useState(false);

  const os = props.row.original.oS;
  const id = props.row.original.id;
  const severity = props.row.original.severity;
  const compressedID = props.row.original.compressedID;
  const compressedIDfull = props.row.original.compressedIDfull;

  const osLabel =
    os === "linux22" ? "linux" : os === "macos16" ? "macos" : os === "andro13" ? "and13" : os;

  // An archive row opens its content inside the modal instead of a
  // report, so there is nothing to export: keep it as plain info text.
  if (isCompressedItself(compressedID, compressedIDfull, id)) {
    return (
      <div className="dashboard__table__os">
        <p>{osLabel}</p>
      </div>
    );
  }

  const clickHandler = (e) => {
    // The row itself opens the analysis report, so keep the click here
    e.stopPropagation();

    if (!id) return;

    history.push({
      pathname: os === "andro13" ? "/android-report-export" : "/report-export",
      search: `?data=${id}&state=${severity}`,
      state: { clickedFileID: id },
    });
  };

  return (
    <button
      className="listGroup__check-with-ai listGroup__os-report"
      title="Generate report"
      onClick={clickHandler}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}>
      {hovered ? "PDF" : osLabel}
    </button>
  );
};

export default OsReportExport;
